/*
 * RM Routes – ordering rules
 * - Master switch: Admin > Content > Metaobjects > Ordering status (Green / Red).
 *   Red = ordering closed site-wide (window.RM_STATUS.open === false).
 * - Ordering window (Central time): Sun 12:00am -> Thu 5pm = Friday + Saturday pickup
 *                                   Thu 5pm -> Fri 5pm      = Saturday only
 *                                   Fri 5pm -> Sun 12:00am   = closed
 * - Saturday-only stops can't be booked for Friday
 * - Tri-State and North Carolina items can't share a cart
 * - Notice (not a block) when a cart has two different days or stops
 * - Keeps the green/red light ([data-rm-light]) in step with the weekly window
 * Day and stop come from the product options app as line item properties.
 */
(function () {
  'use strict';

  var TZ = 'America/Chicago';
  var DAY_PROP = 'Pickup Day';
  var STOP_PROP = 'Pickup Stop';
  var STATUS = window.RM_STATUS || { open: true, closedMsg: '' };

  // Stop label (must match the option value exactly) -> route, and Saturday-only flag.
  var STOPS = {
    'Trenton, GA – Food City': { route: 'Tri-State', satOnly: true },
    'Chattanooga, TN – Lookout Valley Walmart (Exit 174)': { route: 'Tri-State', satOnly: true },
    'Cleveland, TN – Pilot Travel Center': { route: 'Tri-State' },
    'Ooltewah, TN – Walmart Supercenter': { route: 'Tri-State' },
    'Chattanooga, TN – Bass Pro Shops': { route: 'Tri-State' },
    'Dalton, GA – Murphy USA (by Home Depot)': { route: 'Tri-State' },
    "Calhoun, GA – Buc-ee's": { route: 'Tri-State' },
    'Cartersville, GA – Walmart Supercenter': { route: 'Tri-State' },
    'Fort Payne, AL – Walmart Supercenter': { route: 'Tri-State' },
    'Scottsboro, AL – Walmart Supercenter': { route: 'Tri-State' },
    'Gurley, AL – Dollar General': { route: 'Tri-State' },
    'Owens Cross Roads, AL – Walmart Supercenter': { route: 'Tri-State' },
    'Huntsville, AL – Hospital Medical Mall': { route: 'Tri-State' },
    "Madison, AL – Sam's Club": { route: 'Tri-State' },
    "Athens, AL – Buc-ee's": { route: 'Tri-State' },
    'Hartselle, AL – Chevron (Exit 328)': { route: 'Tri-State' },
    "Cullman, AL – Love's Travel Stop (Exit 305)": { route: 'Tri-State' },
    'Gastonia, NC – Circle K': { route: 'North Carolina', satOnly: true },
    'Belmont, NC – Murphy USA (Walmart)': { route: 'North Carolina', satOnly: true },
    'Pineville, NC – Walmart': { route: 'North Carolina', satOnly: true },
    'Concord, NC – 5825 Thunder Rd': { route: 'North Carolina', satOnly: true },
    'Mooresville, NC – 169 Norman Station Blvd': { route: 'North Carolina', satOnly: true },
    "Statesville, NC – Weigel's": { route: 'North Carolina', satOnly: true },
    'Hickory, NC – Walmart Supercenter': { route: 'North Carolina', satOnly: true },
    'Morganton, NC': { route: 'North Carolina', satOnly: true },
    'Black Mountain, NC – Ingles (Exit 64)': { route: 'North Carolina', satOnly: true },
    'Asheville, NC – The Home Depot': { route: 'North Carolina', satOnly: true },
    'Brevard, NC': { route: 'North Carolina', satOnly: true }
  };

  var MSG = {
    season: (STATUS.closedMsg ? STATUS.closedMsg.replace(/\.?\s*$/, '. ') : 'Ordering is closed right now. ') + 'Join the weekly crawfish report on our homepage to hear the day ordering opens.',
    closed: 'Ordering for this week is closed. It reopens Sunday for next week’s pickups.',
    satOnly: 'Friday pickup is closed for this week (cutoff Thursday 5 pm CT). Saturday pickup is open until Friday 5 pm CT.',
    open: 'Order by Thursday 5 pm CT for Friday pickup, or Friday 5 pm CT for Saturday pickup.',
    fridayClosed: 'Friday pickup closed Thursday at 5 pm CT. Choose Saturday instead.',
    satOnlyStop: 'That stop is Saturday only. Choose Saturday.',
    missing: 'Choose a pickup day and stop before adding to cart.',
    mixedRoute: 'Tri-State and North Carolina orders have to be placed separately. Check out your current cart first, or remove those items.',
    mixedDays: 'Heads up: your cart now has pickups on more than one day or at more than one stop. Each item will be at the day and stop you picked for it. Continue?'
  };

  // Late-order note shown once a cutoff has passed (never off-season).
  var PHONE = '(205) 441-3248';
  var PHONE_SMS = 'sms:2054413248';
  var LATE = {
    satOnly: { lead: 'Missed the Friday cutoff?', body: ' Send your name, stop and order. We bring a few extra sacks each week and will do our best to fit you in, but late orders aren’t guaranteed.' },
    closed: { lead: 'Missed this week’s cutoff?', body: ' Send your name, stop and order. We bring a few extra sacks each week and will do our best to fit you in, but late orders aren’t guaranteed.' }
  };
  function lateNode(state, compact) {
    var t = LATE[state];
    if (!t) return null;
    var wrap = document.createElement('span');
    var b = document.createElement('strong');
    b.textContent = t.lead + ' ';
    var a = document.createElement('a');
    a.href = PHONE_SMS + '?&body=' + encodeURIComponent('Late order: my name is , my stop is , and I need ');
    a.textContent = 'Text ' + PHONE;
    a.style.cssText = 'color:inherit;text-decoration:underline;font-weight:700;white-space:nowrap';
    wrap.appendChild(b);
    wrap.appendChild(a);
    wrap.appendChild(document.createTextNode(compact ? ' – we’ll try to fit you in from our extras (not guaranteed).' : '.' + t.body));
    return wrap;
  }
  // Show or hide the late-order box right after an anchor element.
  function lateBox(anchor, state, id) {
    if (!anchor || !anchor.parentNode) return;
    var el = document.getElementById(id);
    var want = !!LATE[state];
    if (!want) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.setAttribute('role', 'note');
      el.style.cssText = 'margin:0 0 12px;padding:10px 12px;border-radius:8px;font-size:14px;line-height:1.45;background:#fff8e6;border:1px solid #f0d58a;color:#4a3b06;';
      anchor.parentNode.insertBefore(el, anchor);
    }
    if (el.getAttribute('data-state') !== state) {
      el.textContent = '';
      el.appendChild(lateNode(state, false));
      el.setAttribute('data-state', state);
    }
    el.hidden = false;
  }

  var norm = function (s) { return String(s || '').replace(/\s+/g, ' ').replace(/[‐-―]/g, '–').trim().toLowerCase(); };
  var STOP_INDEX = {};
  Object.keys(STOPS).forEach(function (k) { STOP_INDEX[norm(k)] = STOPS[k]; });
  var stopInfo = function (v) { return STOP_INDEX[norm(v)] || null; };
  var isShut = function (state) { return state === 'closed' || state === 'season'; };

  // ---- Time window in Central time (or 'season' when the light is red) ----
  function window_() {
    if (STATUS.open === false) return 'season';
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    var mins = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
    var five = 17 * 60;
    if (day === 6 || (day === 5 && mins >= five)) return 'closed';
    if ((day === 4 && mins >= five) || (day === 5 && mins < five)) return 'satOnly';
    return 'open';
  }

  // ---- Green/red light follows the weekly window while the season is open ----
  function applyLight(state) {
    document.querySelectorAll('[data-rm-light]').forEach(function (el) {
      if (state === 'season') return; // red, set by the admin
      var label = el.querySelector('.rm-light__label');
      var msg = el.querySelector('.rm-light__msg');
      var green = state !== 'closed';
      var l, m;
      if (state === 'closed') { l = 'Closed this week'; m = 'Ordering reopens Sunday for next week’s pickups.'; }
      else if (state === 'satOnly') { l = 'Open: Saturday pickup'; m = 'Friday pickup has closed. Saturday orders close Friday 5 pm CT.'; }
      else { l = 'Ordering open'; m = el.getAttribute('data-open-msg') || ''; }
      el.classList.toggle('is-green', green);
      el.classList.toggle('is-red', !green);
      if (label && label.textContent !== l) label.textContent = l;
      if (msg && msg.textContent !== m) msg.textContent = m;
      var late = el.querySelector('.rm-light__late');
      if (LATE[state]) {
        if (!late) { late = document.createElement('span'); late.className = 'rm-light__late'; late.style.cssText = 'flex-basis:100%;font-size:14px;opacity:.95'; el.appendChild(late); }
        if (late.getAttribute('data-state') !== state) { late.textContent = ''; late.appendChild(lateNode(state, true)); late.setAttribute('data-state', state); }
        late.hidden = false;
      } else if (late) { late.hidden = true; }
    });
  }

  // ---- Rule checks ----
  function checkItem(day, stop, state) {
    if (isShut(state)) return MSG[state];
    if (!day || !stop) return MSG.missing;
    var isFri = norm(day).indexOf('friday') === 0;
    var info = stopInfo(stop);
    if (isFri && state === 'satOnly') return MSG.fridayClosed;
    if (isFri && info && info.satOnly) return MSG.satOnlyStop;
    return null;
  }
  // Find a property by name, ignoring case, spacing and any suffix the options app adds.
  function pick(obj, name) {
    var want = norm(name), found = null;
    Object.keys(obj || {}).forEach(function (k) {
      var nk = norm(k).replace(/^_+/, '');
      if (found === null && (nk === want || nk.indexOf(want) === 0)) found = obj[k];
    });
    return found;
  }
  function lineProps(item) {
    var p = item.properties || {};
    return { day: pick(p, DAY_PROP), stop: pick(p, STOP_PROP) };
  }
  function formProps(form) {
    var o = {};
    new FormData(form).forEach(function (v, k) {
      var m = /^properties\[(.*)\]$/.exec(k);
      if (m && v) o[m[1]] = v;
    });
    return { day: pick(o, DAY_PROP), stop: pick(o, STOP_PROP) };
  }
  function cartIssues(items, state) {
    var routes = {}, combos = {}, errors = [];
    if (state === 'season' && items.length) errors.push(MSG.season);
    items.forEach(function (it) {
      var lp = lineProps(it);
      if (!lp.day && !lp.stop) return; // item without pickup options
      var e = state === 'season' ? null : checkItem(lp.day, lp.stop, state);
      if (e) errors.push(it.product_title + ': ' + e);
      var info = stopInfo(lp.stop);
      if (info) routes[info.route] = true;
      combos[norm(lp.day) + '|' + norm(lp.stop)] = true;
    });
    if (Object.keys(routes).length > 1) errors.unshift(MSG.mixedRoute);
    return { errors: errors, mixed: Object.keys(combos).length > 1 };
  }
  function getCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  // ---- UI helpers ----
  function notice(anchor, text, kind, id) {
    if (!anchor) return;
    var el = id && document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      if (id) el.id = id;
      el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      el.style.cssText = 'margin:0 0 12px;padding:10px 12px;border-radius:8px;font-size:14px;line-height:1.4;';
      anchor.parentNode.insertBefore(el, anchor);
    }
    el.style.background = kind === 'error' ? '#fdecea' : '#f3f1ea';
    el.style.color = kind === 'error' ? '#8a1c12' : '#3b3a36';
    el.style.border = '1px solid ' + (kind === 'error' ? '#f5c2bd' : '#e2ddd0');
    if (el.textContent !== text) el.textContent = text; // avoid re-triggering the observer
    if (el.hidden !== !text) el.hidden = !text;
    return el;
  }

  // ---- Product page: banner, Friday lockout, add-to-cart guard ----
  function addForms() { return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')); }

  function isProductPage() {
    var m = document.querySelector('main[data-template]');
    return !!m && m.getAttribute('data-template').indexOf('product') === 0;
  }

  function applyProductState() {
    var state = window_();
    applyLight(state);
    addForms().forEach(function (form, i) {
      if (i === 0 && isProductPage()) {
        notice(form, MSG[state], isShut(state) ? 'error' : 'info', 'rm-window');
        lateBox(form, state, 'rm-late');
      }
      form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]').forEach(function (b) {
        if (isShut(state)) { if (!b.disabled) b.disabled = true; b.setAttribute('data-rm-closed', '1'); }
        else if (b.getAttribute('data-rm-closed')) { b.disabled = false; b.removeAttribute('data-rm-closed'); }
      });
      // Disable Friday choices after the Thursday cutoff.
      form.querySelectorAll('select option, input[type="radio"]').forEach(function (o) {
        if (norm(o.value).indexOf('friday') === 0 && o.disabled !== (state === 'satOnly')) o.disabled = state === 'satOnly';
      });
    });
    syncStopsToDay();
  }

  // When Friday is picked, grey out Saturday-only stops (and clear one if it was chosen).
  function syncStopsToDay() {
    var selects = Array.prototype.slice.call(document.querySelectorAll('select'));
    var daySel = selects.filter(function (s) {
      return Array.prototype.some.call(s.options, function (o) { return norm(o.value) === 'friday' || norm(o.value) === 'saturday'; });
    })[0];
    var stopSels = selects.filter(function (s) {
      return Array.prototype.some.call(s.options, function (o) { return !!stopInfo(o.value); });
    });
    if (!stopSels.length) return;
    var isFri = !!daySel && norm(daySel.value).indexOf('friday') === 0;
    stopSels.forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        var info = stopInfo(o.value);
        var off = !!(info && info.satOnly && isFri);
        if (o.disabled !== off) o.disabled = off;
      });
      var cur = stopInfo(sel.value);
      if (cur && cur.satOnly && isFri) {
        sel.value = '';
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.tagName === 'SELECT') syncStopsToDay();
  }, true);

  // Express checkout buttons skip the cart rules, so hide them.
  (function hideExpressCheckout() {
    var css = 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, [data-shopify="payment-button"] { display: none !important; }';
    var st = document.createElement('style');
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  })();

  var passThrough = false;
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (passThrough) { passThrough = false; return; }
    var fp = formProps(form);
    var day = fp.day;
    var stop = fp.stop;
    var state = window_();
    var errBox = 'rm-add-error';
    // Products without pickup options (none today) skip the checks, except when ordering is shut.
    if (!day && !stop && !isShut(state)) return;
    var err = checkItem(day, stop, state);
    if (err) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      notice(form, err, 'error', errBox);
      return;
    }
    ev.preventDefault(); ev.stopImmediatePropagation();
    getCart().then(function (cart) {
      var info = stopInfo(stop);
      var routes = {}, combos = {};
      cart.items.forEach(function (it) {
        var lp = lineProps(it), i2 = stopInfo(lp.stop);
        if (i2) routes[i2.route] = true;
        if (lp.day || lp.stop) combos[norm(lp.day) + '|' + norm(lp.stop)] = true;
      });
      if (info && Object.keys(routes).length && !routes[info.route]) {
        notice(form, MSG.mixedRoute, 'error', errBox);
        return;
      }
      var key = norm(day) + '|' + norm(stop);
      if (Object.keys(combos).length && !combos[key] && !window.confirm(MSG.mixedDays)) return;
      notice(form, '', 'info', errBox);
      passThrough = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }).catch(function () {
      passThrough = true;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }, true);

  // ---- Background add-to-cart guard ----
  // The theme adds to cart with fetch('/cart/add.js') on button click, so the submit
  // listener above never fires. Check the same rules here and refuse bad adds.
  function bodyProps(body) {
    var o = {}, id = null, qty = '1';
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        body.forEach(function (v, k) {
          var m = /^properties\[(.*)\]$/.exec(k);
          if (m && v) o[m[1]] = v;
          if (k === 'id') id = v;
          if (k === 'quantity') qty = v;
        });
      } else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body);
        var it = (j.items && j.items[0]) || j;
        o = it.properties || {};
        id = it.id;
        qty = it.quantity || '1';
      }
    } catch (e) {}
    return { day: pick(o, DAY_PROP), stop: pick(o, STOP_PROP), key: [id, qty, pick(o, DAY_PROP), pick(o, STOP_PROP)].join('|') };
  }
  function refuse(msg) {
    var form = addForms()[0];
    if (form) notice(form, msg, 'error', 'rm-add-error');
    return Promise.resolve(new Response(JSON.stringify({ status: 422, message: msg, description: msg }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    }));
  }
  if (window.fetch && !window.__rmFetchGuard) {
    window.__rmFetchGuard = true;
    var origFetch = window.fetch.bind(window);
    var lastAdd = null;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'POST' || !/\/cart\/add(\.js)?(\?|$)/.test(url)) return origFetch(input, init);
      var state = window_();
      var bp = bodyProps(init && init.body);
      // The options app and the theme can both send the same add for one click, which
      // doubles the quantity. Reuse the first request when an identical add repeats within 3 seconds.
      if (lastAdd && lastAdd.key === bp.key && Date.now() - lastAdd.at < 3000) {
        return lastAdd.promise.then(function (r) { return r.clone(); });
      }
      var p = guardedAdd(input, init, state, bp);
      lastAdd = { key: bp.key, at: Date.now(), promise: p };
      return p.then(function (r) { return r.clone(); });
    };
    function guardedAdd(input, init, state, bp) {
      if (!bp.day && !bp.stop) {
        // Item without pickup options: only blocked when ordering is shut.
        return isShut(state) ? refuse(MSG[state]) : origFetch(input, init);
      }
      var err = checkItem(bp.day, bp.stop, state);
      if (err) {
        if (LATE[state] && (err === MSG.fridayClosed || err === MSG[state])) err += ' Missed it? Text ' + PHONE + ' and we’ll try to fit you in from our extras.';
        return refuse(err);
      }
      return getCart().then(function (cart) {
        var info = stopInfo(bp.stop), routes = {}, combos = {};
        cart.items.forEach(function (it) {
          var lp = lineProps(it), i2 = stopInfo(lp.stop);
          if (i2) routes[i2.route] = true;
          if (lp.day || lp.stop) combos[norm(lp.day) + '|' + norm(lp.stop)] = true;
        });
        if (info && Object.keys(routes).length && !routes[info.route]) return refuse(MSG.mixedRoute);
        var key = norm(bp.day) + '|' + norm(bp.stop);
        if (Object.keys(combos).length && !combos[key] && !window.confirm(MSG.mixedDays)) {
          return refuse('Not added. Pick the same day and stop as the rest of your cart, or check out separately.');
        }
        var form = addForms()[0];
        if (form) notice(form, '', 'info', 'rm-add-error');
        return origFetch(input, init);
      }, function () { return origFetch(input, init); });
    }
  }

  // ---- Cart & checkout guard ----
  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-rm-checkout]');
  }
  var checkoutOk = false;
  document.addEventListener('click', function (ev) {
    var btn = isCheckoutTrigger(ev.target);
    if (!btn) return;
    if (checkoutOk) { checkoutOk = false; return; }
    ev.preventDefault(); ev.stopImmediatePropagation();
    var anchor = btn.closest('form') || btn;
    if (window_() === 'season') { notice(anchor, MSG.season, 'error', 'rm-cart-error'); return; }
    getCart().then(function (cart) {
      var res = cartIssues(cart.items, window_());
      if (res.errors.length) { notice(anchor, res.errors.join(' '), 'error', 'rm-cart-error'); lateBox(anchor, window_(), 'rm-cart-late'); return; }
      if (res.mixed && !window.confirm(MSG.mixedDays)) return;
      notice(anchor, '', 'info', 'rm-cart-error');
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
    }).catch(function () { checkoutOk = true; btn.click(); });
  }, true);

  // Cart page banner showing the current state.
  function applyCartState() {
    var cartForm = document.querySelector('form[action*="/cart"]:not([action*="/cart/add"])');
    if (!cartForm || !/\/cart(\?|$)/.test(location.pathname + location.search)) return;
    getCart().then(function (cart) {
      var res = cartIssues(cart.items, window_());
      lateBox(cartForm, res.errors.length ? window_() : 'open', 'rm-cart-late');
      if (res.errors.length) notice(cartForm, res.errors.join(' '), 'error', 'rm-cart-error');
      else if (res.mixed) notice(cartForm, 'Your cart has pickups on more than one day or at more than one stop.', 'info', 'rm-cart-error');
    }).catch(function () {});
  }

  function init() { applyProductState(); applyCartState(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Re-check every minute so an open tab flips at the cutoff.
  setInterval(applyProductState, 60 * 1000);
  // Option apps render after load; re-apply when the product form changes.
  new MutationObserver(function () { clearTimeout(window.__rmT); window.__rmT = setTimeout(applyProductState, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
